import { useEffect, useState } from "react";
import { getWhoami } from "./adminApi";

export function useIsAdmin(): { isAdmin: boolean; loading: boolean } {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getWhoami()
      .then((result) => {
        if (!cancelled) {
          setIsAdmin(result);
          setLoading(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setIsAdmin(false);
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { isAdmin, loading };
}
